import React from 'react';
import ReactDOM, { createPortal } from 'react-dom';
import Cookie from 'js-cookie';
import { redirectUrl } from "../service/request";
import { isQx } from "./variable";
import { getQxSso, getQxToken } from "../apis/public";
import { message } from "antd";
import ValiLogin from '../components/ValiLogin';
import ValiLoginCopy from '../components/ValiLoginCopy';

const pinyin = require("pinyin");
const colors = [
  { key: 'A', color: '#FF0000' },
  { key: 'B', color: '#FF3300' },
  { key: 'C', color: '#FF6600' },
  { key: 'D', color: '#FFCC00' },
  { key: 'E', color: '#CCFF00' },
  { key: 'F', color: '#99FF00' },
  { key: 'G', color: '#66FF00' },
  { key: 'H', color: '#33FF00' },
  { key: 'I', color: '#00FF00' },
  { key: 'J', color: '#00FF33' },
  { key: 'K', color: '#00FF66' },
  { key: 'L', color: '#00FF99' },
  { key: 'M', color: '#00FFCC' },
  { key: 'N', color: '#0000FF' },
  { key: 'O', color: '#00CCFF' },
  { key: 'P', color: '#0099FF' },
  { key: 'Q', color: '#0066FF' },
  { key: 'R', color: '#0033FF' },
  { key: 'S', color: '#0000FF' },
  { key: 'T', color: '#9900FF' },
  { key: 'U', color: '#CC00FF' },
  { key: 'V', color: '#FF00FF' },
  { key: 'W', color: '#FF0099' },
  { key: 'X', color: '#FF0066' },
  { key: 'Y', color: '#FF0033' },
  { key: 'Z', color: '#8AD3D3' },
]
// 根据用户名设置用户的头像，同时确保每次进入之后显示的头像都是一样的
export const getUserImg = (name: string) => {
  if (name === undefined) {
    return {
      _color: '',
      name: ''
    }
  }
  let _name: string = name.slice(0, 1);
  let _color = '#ff3333';
  let pattern = /^[A-Za-z0-9]+$/; // 判断是否为字母
  if (pattern.test(_name)) {
    colors.map((item: any) => {
      if (item.key === _name.toUpperCase()) {
        _color = item.color;
      }
      return item;
    })
  } else {
    let _pinyin = pinyin(_name);
    let zimu = _pinyin[0][0].substring(0, 1);
    colors.map((item: any) => {
      if (item.key === zimu.toUpperCase()) {
        _color = item.color;
      }
      return item;
    })
  }
  return {
    name: _name,
    color: _color
  }
}

let _element: any = null;
//判断当前用户是否登陆-简易版
export const judgeLogin = () => {
  let _bol = window.localStorage.getItem('userinfo') ? true : false;
  if (_bol) {
    return true;
  } else {
    _element = document.createElement('div');
    // window.document.body.appendChild(_element);
    ReactDOM.render(createPortal(<ValiLogin />, _element), _element);
    return false;
    // return (class Login extends React.Component{
    //   render() {
    //     return createPortal(
    //     <div>123</div>,
    //     _element)
    //   }
    // })
  }
}

export const judgeLoginCopy = () => {
  let _bol = window.localStorage.getItem('userinfo') ? true : false;
  if (_bol) {
    return true;
  } else {
    _element = document.createElement('div');
    // window.document.body.appendChild(_element);
    ReactDOM.render(createPortal(<ValiLoginCopy />, _element), _element);
    return false;
    // return (class Login extends React.Component{
    //   render() {
    //     return createPortal(
    //     <div>123</div>,
    //     _element)
    //   }
    // })
  }
}
// 销毁该div
export const closeLogin = () => {
  if (_element) {
    _element = "";
    window.document.body.style.removeProperty('overflow');
    let _ele: any = window.document.body.childNodes; // 获取里面的所有子节点
    let eles: any = []; // 筛选出里面节点名称为DIV的元素
    Object.values(_ele).forEach((ele: any) => {
      if (ele.nodeName === "DIV") {
        eles.push(ele);
      }
    })
    window.document.body.removeChild(eles[1]);
  }
}


// 判断当前用户是否登陆
export const judgeIsLogin = () => {
  if(process.env.NODE_ENV==='development'){
    // 开发调试
    getQxToken({ code:'' }).then((res: any)=>{
      localStorage.setItem('loginInfo', JSON.stringify(res))
      res.data.profile.id = res?.data?.profile.userId
      localStorage.setItem('userinfo',JSON.stringify(res?.data?.profile))
      localStorage.setItem("token",JSON.stringify(res.data.token))
    })
    return true;
  }else{
    const partnerToken = Cookie.get('TOKEN:PARTNER:qingcloud');
    const userinfo = JSON.parse(window.localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    if (userinfo.id && partnerToken) { // 用户已经登陆
      return true;
    } else {
      if (isQx) { // 全象
        // window.location.href = `https://partner.quanxiangyun.com/login/qingcloud?redirectUrl=${encodeURIComponent('https://partner.quanxiangyun.com/qingcloud/learning')}`
        // let obj: any = {};
        // let str = window.location.search.substr(1);
        // let arr = str.split('&');
        // for (let i = 0; i < arr.length; i++) {
        //   let newArr = arr[i].split('=')
        //   obj[newArr[0]] = newArr[1]
        // }
       
        // 暂定写死
        // window.location.href = `http://partner.titan.localhost/login/qingcloud?redirectUrl=${encodeURIComponent(window.location.origin)}`
        window.location.href = `https://partner.quanxiangyun.com/login/qingcloud?redirectUrl=${encodeURIComponent('https://partner.quanxiangyun.com/qingcloud/learning')}`
        // 从后端获取跳转的路径
        // getQxSso({}).then((res: any) => {
        //   if (res && res.code === 0) {
        //     const { data } = res;
        //     window.location.href = data;
        //   } else {
        //     res && message.error(res.msg);
        //   }
        // })
      } else {
        // window.location.href = redirectUrl; // 调到学院登陆页面
        window.location.href = `https://partner.quanxiangyun.com/login/qingcloud?redirectUrl=${encodeURIComponent('https://partner.quanxiangyun.com/qingcloud/learning')}`
        return false;
      }
    }
  }
  
  
}


// 判断是全象还是学院，是否地址栏拼接用户id
export const judgeIsSplice = (bol?: true) => {
  if (isQx) {
    if (bol) {
      const userinfo = JSON.parse(localStorage.getItem(`userinfo`) || JSON.stringify(null)) || {};
      return `?user_id=${userinfo.id}`;
    }
    return "";
  } else {
    const userinfo = JSON.parse(localStorage.getItem(`userinfo`) || JSON.stringify(null)) || {};
    return `&user_id=${userinfo.id}`;
  }
}
